// extracted by mini-css-extract-plugin
export var formContainer = "_mb-0";
export var message = "_mb-1";